import {styled} from '@mui/material';

const StyledOptionIcon = styled('span')`
	display: inline-flex;
	align-items: center;
	justify-content: center;
	width: 44px;
	height: 44px;
	background-color: #eef6ff;
	border-radius: 50%;
	color: ${({theme}) => theme.palette.primary.main};

	svg {
		width: 15px;
		height: 15px;
	}

	img {
		width: 20px;
		height: auto;
	}
`;

export {StyledOptionIcon};
